import { render, staticRenderFns } from "./BakeryMarathonRating.vue?vue&type=template&id=287d9578&scoped=true&"
import script from "./BakeryMarathonRating.vue?vue&type=script&lang=js&"
export * from "./BakeryMarathonRating.vue?vue&type=script&lang=js&"
import style0 from "./BakeryMarathonRating.vue?vue&type=style&index=0&id=287d9578&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d9578",
  null
  
)

export default component.exports